import { Expose } from "class-transformer";
import { IsBoolean } from "class-validator";

export class SuccessDTO {
  @Expose()
  @IsBoolean()
  success!: number;
}
